import { Injectable, inject } from '@angular/core';
import { UrlService, HttpService } from '@boels/helpers';
import { Observable } from 'rxjs';
import { AlternateList } from '@boels/models';

@Injectable({
  providedIn: 'any',
})
export class BoelsAlternatesGateway {
  private readonly httpService = inject(HttpService);
  private urlService = inject(UrlService);

  getAlternates(
    activeBaseSite: string,
    categoryID: string,
  ): Observable<AlternateList> {
    const url =
      this.urlService.combineUri(activeBaseSite, 'alternates', categoryID) +
      '?fields=DEFAULT';
    return this.httpService.get(url);
  }
}
